<template>
  <div>
    <div v-if="!readonly">
      <label class="f14 fw500 primary--text f14 mb-2">
        {{ title ? title + ' ' : '' }}
        <v-icon class="mt-n1 mr-n1" color="#277faf">mdi-google-maps</v-icon>
        Google search
      </label>
      <div data-v-d3863baa=""
           class="v-input v-input--hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
        <div class="v-input__control">
          <div class="v-input__slot">
            <fieldset aria-hidden="true">
              <legend><span class="notranslate">&ZeroWidthSpace;</span></legend>
            </fieldset>
            <div class="v-text-field__slot">
              <vue-google-autocomplete
                  :key="key"
                  ref="address"
                  :id="randomId"
                  placeholder=""
                  v-on:placechanged="getAddressData"
                  v-model="address_placeholder"
              >
              </vue-google-autocomplete>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border pt-4 pb-5 pa-5">
      <BaseInput
          v-model="data.street"
          :label=" localStorage.translations.pages['sales_project']['project_client-labels']['ulitsa']"
          placeholder=""
          :rules="required ? ['required', 'max100'] : ['max100']"
          @input="changeStreet"
          :view="readonly"
      />
      <BaseInput
          v-model="data.zip"
          :label="localStorage.translations.pages['sales_project']['project_client-labels']['indeks']"
          placeholder=""
          :rules="required ? ['required', 'max100'] : ['max100']"
          @input="changeZip"
          :view="readonly"
          class="my-5"
      />
      <BaseInput
          v-model="data.city"
          :label="localStorage.translations.pages['sales_project']['project_client-labels']['gorod']"
          placeholder=""
          :rules="required ? ['required', 'max50'] : ['max50']"
          @input="changeCity"
          :view="readonly"
      />
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete"
import BaseInput from "components/base/BaseInput";

export default {
  name: "GoogleAutocomplete",
  components: {BaseInput, VueGoogleAutocomplete},
  props: {
    title: {
      type: String,
      default: ''
    },
    street: {
      type: String,
      default: '',
    },
    zip: {
      type: String,
      default: '',
    },
    city: {
      type: String,
      default: '',
    },
    id: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    onChange: {},
    readonly: Boolean,
    externalData: {
      type: [Number, String, Array, Object],
      default: null
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    address: "",
    key: 0,
  }),
  computed: {
    randomId() {
      let min = Math.ceil(1)
      let max = Math.floor(1000)
      return 'map_' + Math.floor(Math.random() * (max - min + 1)) + min
    },
    data() {
      return {
        street: this.street || '',
        zip: this.zip || '',
        city: this.city || '',
      }
    },
    address_placeholder() {
      if (this.address) {
        return this.address.route + String(this.address.street_number ? ' ' + this.address.street_number : '') +
            String(this.address.postal_code ? ', ' + this.address.postal_code : '') +
            String(this.address.locality ? ', ' + this.address.locality : '')
      }
      return String(this.street ? this.street : '') +
          String(this.zip ? ', ' + this.zip : '' ) +
          String(this.city ? ', ' + this.city : '')
    }
  },
  methods: {
    getAddressData(addressData, placeResultData, id) {
      this.address = addressData
      let data = {
        street: String(this.address.route || '') + ' ' + String(this.address.street_number || ''),
        zip: String(this.address.postal_code || ''),
        city: String(this.address.locality || ''),
      }
      this.saveChanges(data)
    },

    saveChanges(data) {
      this.address = ""
      if (this.id !== null) data.id = this.id
      if (this.externalData) data.externalData = this.externalData
      if (this.onChange) this.onChange(data)
      this.street = data.street
      this.zip = data.zip
      this.city = data.city
      this.key++

    },

    changeStreet(data) {
      this.saveChanges({
        street: data,
        zip: this.data.zip,
        city: this.data.city,
      })
    },
    changeZip(data) {
      this.saveChanges({
        street: this.data.street,
        zip: data,
        city: this.data.city,
      })
    },
    changeCity(data) {
      this.saveChanges({
        street: this.data.street,
        zip: this.data.zip,
        city: data,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.v-input__slot {
  height: 48px;
}

legend {
  width: 0;
}

.border {
  border: 1px solid rgba(black, 0.1);
  border-radius: 10px;
}
</style>